import { render, staticRenderFns } from "./AdminSampleDataConfig.vue?vue&type=template&id=dd61f19c"
import script from "./AdminSampleDataConfig.vue?vue&type=script&lang=ts"
export * from "./AdminSampleDataConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports